
const reviews = [
  {
    name: '田中 美咲様',
    age: '40代女性',
    image: 'https://public.readdy.ai/ai/img_res/41f38679b66efcf4eda98148db283361.jpg',
    comment: '長年悩んでいた肩こりが、こちらの治療で驚くほど改善しました。先生方の丁寧な説明と施術に、いつも安心して通っています。',
    bgColor: 'bg-sub',
  },
  {
    name: '佐藤 健一様',
    age: '50代男性',
    image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20satisfied%20Japanese%20man%20in%20his%2050s%20with%20gentle%20smile%2C%20casual%20shirt%2C%20sitting%20in%20comfortable%20clinic%20setting%2C%20natural%20lighting%2C%20expression%20of%20relief%20and%20gratitude%2C%20clean%20modern%20background%2C%20professional%20photography%2C%20trustful%20and%20content%20atmosphere&width=400&height=400&seq=review-patient-2&orientation=squarish',
    comment: '腰痛で歩くのも辛かったのですが、定期的に通うことで日常生活が楽になりました。スタッフの皆さんも親切で、通いやすい雰囲気です。',
    bgColor: 'bg-primary/10',
  },
  {
    name: '山本 由美様',
    age: '30代女性',
    image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20cheerful%20Japanese%20woman%20in%20her%2030s%20with%20bright%20smile%2C%20modern%20casual%20wear%2C%20sitting%20in%20welcoming%20clinic%20environment%2C%20soft%20natural%20lighting%2C%20youthful%20and%20healthy%20appearance%2C%20clean%20background%20with%20plants%2C%20professional%20photography%2C%20joyful%20and%20satisfied%20expression&width=400&height=400&seq=review-patient-3&orientation=squarish',
    comment: '美容鍼を受けてから、肌のハリが戻り、周りからも「若返った」と言われます。リラックスできる空間で、毎回癒されています。',
    bgColor: 'bg-accent/20',
  },
  {
    name: '鈴木 誠様',
    age: '60代男性',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20middle-aged%20man%20in%20his%2050s%20smiling%20warmly%20wearing%20casual%20comfortable%20shirt%20in%20bright%20modern%20clinic%20setting%20relaxed%20friendly%20atmosphere%20professional%20portrait%20high%20quality&width=100&height=100&seq=review-suzuki-makoto-v2&orientation=squarish',
    comment: '自律神経の不調で悩んでいましたが、こちらの治療で体調が安定してきました。先生の豊富な知識と経験に、いつも感謝しています。',
    bgColor: 'bg-sub',
  },
];

const ReviewsSection = () => {
  return (
    <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-6 bg-gradient-to-b from-white to-sub/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <div className="inline-block bg-white px-4 py-1 rounded-full mb-4 shadow-sm">
            <span className="text-primary text-xs font-medium tracking-wider uppercase">Reviews</span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-primary mb-3 sm:mb-4 px-4">
            患者様の<strong>声</strong>
          </h2>
          <p className="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto px-4">
            <strong>岡山市</strong>を中心に、多くの患者様から信頼をいただいています
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {reviews.map((review, index) => (
            <article
              key={index}
              className={`${review.bgColor} rounded-2xl sm:rounded-3xl p-6 sm:p-8 hover:shadow-xl transition-all duration-300 cursor-pointer group`}
            >
              <div className="flex flex-col">
                <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 overflow-hidden rounded-full ring-2 sm:ring-4 ring-white shadow-md flex-shrink-0">
                    <img
                      src={review.image}
                      alt={review.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 text-sm sm:text-base">{review.name}</h3>
                    <p className="text-gray-600 text-xs sm:text-sm">{review.age}</p>
                  </div>
                </div>
                
                <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center mb-3 sm:mb-4">
                  <i className="ri-double-quotes-l text-2xl sm:text-3xl text-primary/30"></i>
                </div>
                
                <p className="text-gray-700 text-xs sm:text-sm leading-relaxed">
                  {review.comment}
                </p>
                
                <div className="flex gap-1 mt-4 sm:mt-6">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-sm sm:text-base"></i>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
